import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { fetchJobs } from '../services/api';
import { jobTitle } from '../constants/jobOptions';
import './DesktopRightPanel.css';

export default function DesktopRightPanel() {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    fetchJobs({ limit: 5 })
      .then((res) => {
        const data = res.data;
        const list = Array.isArray(data) ? data : (data?.jobs ?? data?.data ?? []);
        setJobs(list.slice(0, 5));
      })
      .catch(() => {});
  }, []);

  return (
    <aside className="d-right">
      <div className="d-right__card">
        <div className="d-right__heading">
          <TrendingUp size={18} />
          <span>Beliebt</span>
        </div>

        {jobs.map((job) => {
          const company = job.company_name ?? job.company ?? '';
          const initial = company[0]?.toUpperCase() ?? 'J';
          const location = job.location ?? job.city ?? '';

          return (
            <Link
              key={job.id}
              to={`/jobs/${job.id}`}
              className="d-right__job"
            >
              <div className="d-right__job-logo">{initial}</div>
              <div className="d-right__job-info">
                <div className="d-right__job-title">{jobTitle(job.title)}</div>
                <div className="d-right__job-sub">
                  {company}{location ? ` · ${location}` : ''}
                </div>
              </div>
            </Link>
          );
        })}

        <Link to="/search" className="d-right__see-all">
          Alle Jobs ansehen →
        </Link>
      </div>

      <div className="d-right__tagline">
        <strong>LetsCareers</strong>
        Dein nächster Job. Gleich um die Ecke.
      </div>
    </aside>
  );
}
